import { computed, inject, Injectable } from "@angular/core";
import { Origin } from "../../models/types/general-types";
import { UserStoreService } from "../store/user/user.store.service";
import { AppStateStoreService } from "@bitwarden/web-vault/app/services/store/app-state/app-state.store.service";

@Injectable({
  providedIn: "root",
})
export class SignalGlowService {
  private userStoreService = inject(UserStoreService);
  private appState = inject(AppStateStoreService);
  isSignal = computed(() => {
    const isPremium = this.userStoreService?.subscription?.activeSubscription()?.isPremium;
    // currently behaviour is in the wizard, we don't allow synced account feature for a hotfix that sync account break the wizard, so the glow animation also need to be disabled
    const isInWizard = this.appState.wizard().isVisible;
    const isAllManualAccounts = this.userStoreService.accounts
      .accountViews()
      ?.every((account) => account.origin === Origin.manual);

    return isPremium && isAllManualAccounts && !isInWizard;
  });
}
